"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAnnouncements = fetchAnnouncements;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var types = _interopRequireWildcard(require("../store/actions/actionTypes"));

var _AnnouncementParser = require("./AnnouncementParser.js");

var _AnnouncementsLocaleMapper = require("./AnnouncementsLocaleMapper");

var _store = _interopRequireDefault(require("../store/store"));

var NotificationSelectors = _interopRequireWildcard(require("../store/reducers/NotificationReducer"));

var _PulseApiHelper = _interopRequireDefault(require("../service/PulseApiHelper"));

/*************************************************************************
 ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/

/**
 * fetch announcements JSON data from status.adobe.com
 * @param {store} store Redux store to dispatch Announcements Fetched fn.
 */
function fetchAnnouncements(_x) {
  return _fetchAnnouncements.apply(this, arguments);
}

function _fetchAnnouncements() {
  _fetchAnnouncements = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(store) {
    var pulseApiHelper, url, response, localizationresponse, locale, data, localizationdata, parsed_data;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pulseApiHelper = new _PulseApiHelper.default();
            url = new URL("".concat(pulseApiHelper.getSKMSHostUrl(), "/adobestatus/currentstatus"));
            _context.prev = 2;
            _context.next = 5;
            return fetch(url, {
              method: 'GET'
            });

          case 5:
            response = _context.sent;
            locale = (0, _AnnouncementsLocaleMapper.getAnnouncementsLocale)(NotificationSelectors.getLocale(store.getState()));
            _context.next = 9;
            return fetch("".concat(pulseApiHelper.getSKMSHostUrl(), "/adobestatus/").concat(locale), {
              method: 'GET'
            });

          case 9:
            localizationresponse = _context.sent;
            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);
            console.log(_context.t0);

          case 15:
            if (!response || !response.ok || !localizationresponse || !localizationresponse.ok) {
              console.error("AnnouncementLongPoll fetch failed, HTTP status ".concat(response ? response.status : 'unknown'));
            }

            if (!response) {
              _context.next = 22;
              break;
            }

            _context.next = 19;
            return response.json();

          case 19:
            _context.t1 = _context.sent;
            _context.next = 23;
            break;

          case 22:
            _context.t1 = {};

          case 23:
            data = _context.t1;

            if (!localizationresponse) {
              _context.next = 30;
              break;
            }

            _context.next = 27;
            return localizationresponse.json();

          case 27:
            _context.t2 = _context.sent;
            _context.next = 31;
            break;

          case 30:
            _context.t2 = {};

          case 31:
            localizationdata = _context.t2;
            parsed_data = (0, _AnnouncementParser.getFinalAnnouncementList)(data, localizationdata);
            store.dispatch({
              type: types.ANNOUNCEMENTS_FETCHED,
              payload: parsed_data
            });

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 12]]);
  }));
  return _fetchAnnouncements.apply(this, arguments);
}